import { verifActivity , involvedActivity , memberActivityPvStat } from '@/api/Subsidy';

const state = {
  
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
};
const actions = {
  verifActivity({ commit },data) {
    return new Promise((resolve)=>{
      verifActivity(data).then(res => {
        resolve(res.data)
      });
    })
  },

  involvedActivity({ commit },data) {
    return new Promise((resolve)=>{
      involvedActivity(data).then(res => {
        resolve(res.data)
      });
    })
  },

  memberActivityPvStat({ commit },data) {
    return new Promise((resolve)=>{
      memberActivityPvStat(data).then(res => {
        resolve(res.data)
      });
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
